import Home from "../../components/Landing/Home";
import { CheckToken } from "../login/AccessToken";
import React, { useEffect, useState } from 'react';
import axios from 'axios';

function DoctorHome({ setSearchText }) {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem('accessToken') || ''
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  useEffect(() => {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        .then((res) => {
          if (res.data.status === "Success") {
            console.log("data", res.data)
            sessionStorage.setItem("isAbdmEnabled", res.data.abdm_enabled || false);
            sessionStorage.setItem("doctor_id", res.data.doctor_id || "");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

  }, []);
  return <Home type="doctor" setSearchText={setSearchText} />;
}
export default DoctorHome;
